let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jUcDz")).then(() => parcelRequire('9ZVpZ'));